export const FIRST_LOGIN_MESSAGE =
  'Welcome aboard! Create tailored resumes faster and apply with confidence.';

export const RETURNING_LOGIN_MESSAGE = 'Welcome back!';

/**
 * Picks the sign-in toast copy. `isFirstLogin` comes from the backend
 * (account-level, so it is correct across browsers/devices): a first-ever
 * login is congratulated, a returning login is greeted as such.
 */
export const pickLoginMessage = (isFirstLogin?: boolean): string =>
  isFirstLogin ? FIRST_LOGIN_MESSAGE : RETURNING_LOGIN_MESSAGE;
